import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import './NonRxProductImageDialog.css';

const NonRxProductImageDialog = ({
  open,
  item,
  t,
  saving,
  onClose,
  onSave,
}) => {
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');

  useEffect(() => {
    if (!open) {
      setImageFile(null);
      setImagePreview('');
      return;
    }
    setImageFile(null);
    setImagePreview(item && item.image_url ? item.image_url : '');
  }, [open, item]);

  const handleDrop = (files) => {
    const file = files && files[0];
    if (!file) {
      return;
    }
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSave = () => {
    if (!imageFile || saving) {
      return;
    }
    onSave(imageFile);
  };

  const productLabel = item
    ? [item.item_number, item.description].filter(Boolean).join(' — ')
    : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle className="assign-non-rx-image-dialog-title">
        {t('Assign.NonRxCart.ImageDialogTitle', {
          defaultValue: 'Product photo',
        })}
      </DialogTitle>
      <DialogContent className="assign-non-rx-image-dialog-content">
        {productLabel ? (
          <Typography variant="body2" className="assign-non-rx-image-dialog-product">
            {productLabel}
          </Typography>
        ) : null}
        <Typography variant="body2" className="assign-non-rx-image-dialog-hint">
          {t('Assign.NonRxCart.ImageDialogHint', {
            defaultValue:
              'Upload a photo for this Marketplace catalog product. It will be saved to your catalog and shown on Deliver.',
          })}
        </Typography>
        <Dropzone
          accept="image/jpeg,image/png,image/jpg,image/webp"
          multiple={false}
          onDrop={handleDrop}
          className={
            'assign-non-rx-image-dropzone' +
            (imagePreview ? ' assign-non-rx-image-dropzone--filled' : '')
          }
          activeClassName="assign-non-rx-image-dropzone--active"
        >
          {imagePreview ? (
            <React.Fragment>
              <img src={imagePreview} alt="" />
              <span className="assign-non-rx-image-dropzone-overlay">
                {t('Assign.NonRxCart.ImageDialogReplace', {
                  defaultValue: 'Click or drop to replace',
                })}
              </span>
            </React.Fragment>
          ) : (
            <div className="assign-non-rx-image-dropzone-placeholder">
              <CloudUploadOutlinedIcon className="assign-non-rx-image-dropzone-icon" />
              <Typography variant="body2">
                {t('Assign.NonRxCart.ImageDialogDrop', {
                  defaultValue: 'Drop photo or click to upload',
                })}
              </Typography>
              <Typography variant="caption">JPG, PNG, WEBP</Typography>
            </div>
          )}
        </Dropzone>
        <Typography variant="caption" className="assign-non-rx-image-dialog-requirements">
          {t('Assign.NonRxCart.ImageDialogRequirements', {
            defaultValue:
              'New catalog products require Item #, Description, and UPC on the row before saving.',
          })}
        </Typography>
      </DialogContent>
      <DialogActions className="assign-non-rx-image-dialog-actions">
        <Button onClick={onClose} disabled={saving}>
          {t('Global.Cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={!imageFile || saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {t('Assign.NonRxCart.ImageDialogSave', {
            defaultValue: 'Save to catalog',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NonRxProductImageDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  item: PropTypes.object,
  t: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

NonRxProductImageDialog.defaultProps = {
  item: null,
  saving: false,
};

export default NonRxProductImageDialog;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/NonRxProductImageDialog.jsx